import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import app from "./firebase";
import firebase from "firebase/app";
import "firebase/database";
import { BsFillSquareFill } from "react-icons/bs";
import { FaProcedures } from "react-icons/fa";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { css } from "@emotion/react";
import FadeLoader from "react-spinners/FadeLoader";

const HospitalsClass = () => {
  const history = useHistory();
  const [loading, setLoading] =useState(true);
  const [hospitals, setHospitals] = useState([]);

  const handleClick=(e)=>{
    const id = e.currentTarget.id;
    const path =`/hospitals/`+ id;
    history.push(path);
  }

  console.log("useState Hospitals: ", hospitals);

  useEffect(()=>{
    const hospitalsData = firebase.database().ref();
    hospitalsData.on("value", (snapshot)=>{
      setLoading(false);
      setHospitals(Object.keys(snapshot.val().Hospitals))
    })

  },[]);
  
  const getHospitalsUsingMap = () =>{
    return hospitals.map((hospital, index)=>
      <Col lg={2} md={3} xs={4} className="pl-3 pr-3 pt-2">
          <button id={`hospital-${index+1}`} onClick={handleClick} className="btn" >
            <i className="far fa-hospital fa-5x" 
              style={{ color:"grey" }}
              key={`hospital-${index+1}`}>
            </i>
            <center>
              <strong>
                <p className="mt-2">{hospital}</p>
              </strong>
            </center>
          </button>
        </Col>
    )
  }
  return (
    <Container>
      <br></br>
      <div className="px-md-5">
        <h4 className="RoomsTitle">Hospitals</h4>

        <hr></hr>
        {loading? <FadeLoader color={"#008db9"} loading={true} size={40} />:  <Row>{getHospitalsUsingMap()}</Row>}
      </div>
    </Container>
  );
};

export default HospitalsClass;
